import React from "react";
import {ProductDisplayName, ProductName, ProductTooltip, productTooltip} from "../../formatters";

export default (idfield: string, ifFn?: (comp, props) => any) => {
    ifFn = ifFn || ((comp) => comp);
    return {
        header: 'Megnevezés',
        sortable: true,
        filterable: true,
        formatter: (props) => ifFn(<ProductDisplayName value={props.value} row={props.row} idfield={idfield} />, props),
        tooltip: (props) => ifFn(<ProductTooltip row={props.row} idfield={idfield} />, props),
    }
};